import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import special from '@/api/special'
import journal from '@/api/journal'
import operation from '@/api/operation'

import CreateFile from './createFile.dialog.vue'
import help from '@/utils/help'
const columns = [
  {
    title: '',
    enTitle: 'Title',
    width: 300,
    dataIndex: 'titleText',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Guest Editor',
    width: 280,
    dataIndex: 'editorList',
    slot: 'editor'
  },
  {
    title: '',
    enTitle: 'Downloads',
    width: 80,
    dataIndex: 'downloadNum'
    // sort: true
  },
  {
    title: '',
    enTitle: 'Views',
    width: 50,
    dataIndex: 'readNum'
    // sort: true
  },
  {
    title: '',
    enTitle: 'Published Papers',
    width: 140,
    dataIndex: 'articleNum',
    slot: 'publishedPaper'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Start Time',
    width: 120,
    dataIndex: 'startTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Deadline',
    width: 120,
    dataIndex: 'endTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 230,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
const allColumns = [
  {
    title: '',
    enTitle: 'Title',
    width: 300,
    dataIndex: 'titleText',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Guest Editor',
    width: 280,
    dataIndex: 'editorList',
    slot: 'editor'
  },
  {
    title: '',
    enTitle: 'Journal',
    width: 80,
    dataIndex: 'journal',
    slot: 'journal'
  },
  {
    title: '',
    enTitle: 'Download',
    width: 80,
    dataIndex: 'downloadNum'
    // sort: true
  },
  {
    title: '',
    enTitle: 'View',
    width: 50,
    dataIndex: 'readNum'
    // sort: true
  },
  {
    title: '',
    enTitle: 'Published Paper',
    width: 140,
    dataIndex: 'articleNum',
    slot: 'publishedPaper'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 80,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Start Time',
    width: 120,
    dataIndex: 'startTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'End Time',
    width: 120,
    dataIndex: 'endTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 230,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    CreateFile
  },
  data() {
    return {
      columns,
      allColumns,
      showAdv: false,
      journalList: [],
      dataSource: [],
      openSection: '',
      params: {
        released: '',
        journalId: '',
        volumeId: '',
        issueId: ''
      },
      startDate: [],
      endDate: [],
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      inputData: {},
      pdfType: 'Banner',
      isVisablePDF: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      editorialBoard: 'getEditorialBoard',
      country: 'getCountry',
      user: 'getUser'
    })
  },
  async mounted() {
    await this.getJournalList()
    help.closeAutocomplete()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await special.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      this.journalList.unshift({
        name: 'All',
        id: ''
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        // localStorage.setItem('journalId', this.params.journalId)
      }
      this.getList()
    },
    handleDateChange(date, val) {
      this.params['begin' + val] = date[0] ? date[0].startOf('d') : ''
      this.params['end' + val] = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.$router.push(
        '/publishing/special-issue/add?journalId=' + this.params.journalId
      )
    },
    edit(val) {
      this.$router.push(
        '/publishing/special-issue/edit/' +
          val.id +
          '?journalId=' +
          this.params.journalId
      )
    },
    async able(val) {
      if (!val.released) {
        this.$confirm({
          title: 'Reminder',
          content:
            'Please add GE to the yellow list of <a class="link-color" href="https://www.hydoffice.com:7758/#/access/login" target="_blank">Digital Office Center</a>！When finished, please click Confirm.',
          type: 'warning',
          icon: 'iconConfirm',
          confirmText: 'Confirm'
        }).then(() => {
          this.publish(val)
        })
        return
      }
      this.publish(val)
    },
    async publish(val) {
      const { id, released, version } = val
      await special.batchRelease([
        {
          id,
          released: !released,
          version
        }
      ])
      await operation.add({
        authorityCode: 'WEBSITE.SPECIAL_ISSUES.PUBLISH',
        type: 'PUBLISH',
        info: `Publish/Unpublish: ${val.code}`,
        detail: `Change from 【${released ? 'Publish' : 'Unpublish'}】 to 【${
          released ? 'Unpublish' : 'Publish'
        }】`
      })
      let content = 'This Special issue has been published!'
      if (released) {
        content = 'This Special issue has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this special issue?',
        content:
          'Please be aware of once this special issue is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await special.del(val.id)
        await operation.add({
          authorityCode: 'WEBSITE.SPECIAL_ISSUES.DELETE',
          type: 'DELETE',
          info: `Delete The Special Issue:  ${val.titleText}`,
          detail: `【Title】: ${val.titleText}<br/>
          【End Time】: ${
            val.endTime
              ? this.$moment(val.endTime).format('DD / MM / YYYY')
              : ''
          } `
        })
        this.$message.success({
          title: 'Success',
          content: 'This Special issue has been deleted!'
        })
        this.getList()
      })
    },
    handleClear() {
      this.params.keyword = ''
      this.params.beginStartTime = ''
      this.params.endStartTime = ''
      this.params.beginEndTime = ''
      this.params.endEndTime = ''
      this.startDate = []
      this.endDate = []
      this.getList()
    },
    application() {
      this.$router.push(
        `/publishing/special-issue/application?journalId=${this.params.journalId}`
      )
    },
    changeJournal() {
      this.getList()
    },
    // publish() {},
    article(val) {
      this.$router.push('/publishing/special-issue/' + val.id)
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },

    setOrder(val) {
      this.params.sorted = val
      this.getList()
    },
    async openWebsite(val) {
      let url = `/journal/${val.journal.name}/test/special/${
        val.id
      }?token=${localStorage.getItem('token')}`
      const { host } = window.location
      if (
        host.includes('192.168.5') ||
        host.includes('192.168.4.34') ||
        host.includes('102.168.4.21') ||
        host.includes('localhost')
      ) {
        url = 'http://192.168.5.18:3020' + url
      } else if (
        host.includes('192.168.4.23') ||
        host.includes('imrpress.tech:9100')
      ) {
        url = 'http://www.imrpress.tech' + url
      } else if (host.includes('imrpress.tech:8100')) {
        url = 'http://www.imrpress.tech:9000' + url
      } else if (host.includes('propub.com')) {
        url = 'https://www.imrpress.com' + url
      } else {
        url = 'http://192.168.5.18:3020' + url
      }
      window.open(url)
    },
    cancel() {
      this.isVisablePDF = false
    },
    createCanvans(val, type) {
      this.inputData = val
      this.pdfType = type
      this.isVisablePDF = true
    },
    async exp() {
      this.loading = true
      try {
        const res = await special.export(this.params)
        help.download(res.url, res.fileName)
      } catch (e) {
        this.loading = false
      }
      this.loading = false
    }
  }
}
